export const lotteryPromotions = [
    {
        id: 1,
        company: {
            logo: {
                urls: {
                    small: require('@/assets/logo-mpromo.svg')
                }
            }
        },
        eanConflict: false,
        favorite: true,
        end_at: '2022-08-31T23:59:00.000+02:00',
        logo: {
            urls: {
                big: require('@/assets/logo-mpromo.svg'),
                medium: require('@/assets/logo-mpromo.svg'),
                small: require('@/assets/logo-mpromo.svg')
            }
        },
        name: 'Promocja 1',
        start_at: '2021-07-23T17:20:00.000+02:00',
        products: [
            {
                id: 11,
                promotional: true,
                refund_total: [0.51],
                count: 1,
                maximum_price: '2.0',
                dict_product: {
                    ean: '12345678901',
                    name: 'Produkt promocyjny 1',
                    image: {
                        urls: {
                            small: require('@/assets/logo-mpromo.svg')
                        }
                    }
                }
            }
        ],
        product_sets: [],
        subscriptions: [
            {
                company_merchant_status: 'active',
                id: 1111111,
                merchant_id: 111,
                state: 'available',
                status: 'available',
                updated_at: '2021-07-23T17:10:21.784+02:00',
                products: [
                    {
                        id: 11,
                        promotional: true,
                        price: '2.0',
                        maximum_price: '2.0',
                        dict_product: {
                            ean: '12345678901',
                            name: 'Produkt promocyjny 1',
                            image: {
                                urls: {
                                    small: require('@/assets/logo-mpromo.svg')
                                }
                            }
                        }
                    }
                ]
            },
            {
                company_merchant_status: 'active',
                id: 1111112,
                merchant_id: 222,
                state: 'available',
                status: 'available',
                updated_at: '2021-07-23T17:10:21.784+02:00',
                products: [
                    {
                        id: 11,
                        promotional: true,
                        maximum_price: '2.0',
                        dict_product: {
                            ean: '12345678901',
                            name: 'Produkt promocyjny 1',
                            image: {
                                urls: {
                                    small: require('@/assets/logo-mpromo.svg')
                                }
                            }
                        }
                    }
                ]
            }
        ],
        minimum_amount_of_refund: '0.51',
        type: 'Promo::PromoItemFixedPrice'
    },
    {
        id: 2,
        company: {
            logo: {
                urls: {
                    small: require('@/assets/logo-mpromo.svg')
                }
            }
        },
        eanConflict: false,
        favorite: false,
        end_at: '2022-08-31T23:59:00.000+02:00',
        name: 'Promocja 2',
        logo: {
            urls: {
                big: require('@/assets/logo-mpromo.svg'),
                medium: require('@/assets/logo-mpromo.svg'),
                small: require('@/assets/logo-mpromo.svg')
            }
        },
        start_at: '2021-07-23T17:20:00.000+02:00',
        products: [
            {
                id: 22,
                promotional: true,
                refund_total: [2.44],
                count: 1,
                maximum_price: '4.0',
                dict_product: {
                    ean: '12345678902',
                    name: 'Produkt promocyjny 2',
                    image: {
                        urls: {
                            small: require('@/assets/logo-mpromo.svg')
                        }
                    }
                }
            }
        ],
        product_sets: [],
        subscriptions: [
            {
                company_merchant_status: 'active',
                id: 2222221,
                merchant_id: 111,
                state: 'available',
                status: 'available',
                updated_at: '2021-07-23T17:10:21.784+02:00',
                products: [
                    {
                        id: 22,
                        promotional: true,
                        maximum_price: '4.0',
                        dict_product: {
                            ean: '12345678902',
                            name: 'Produkt promocyjny 2',
                            image: {
                                urls: {
                                    small: require('@/assets/logo-mpromo.svg')
                                }
                            }
                        }
                    }
                ]
            },
            {
                company_merchant_status: 'active',
                id: 2222222,
                merchant_id: 222,
                state: 'available',
                status: 'available',
                updated_at: '2021-07-23T17:10:21.784+02:00',
                products: [
                    {
                        id: 22,
                        promotional: true,
                        maximum_price: '4.0',
                        dict_product: {
                            ean: '12345678902',
                            name: 'Produkt promocyjny 2',
                            image: {
                                urls: {
                                    small: require('@/assets/logo-mpromo.svg')
                                }
                            }
                        }
                    }
                ]
            }
        ],
        minimum_amount_of_refund: '2.44',
        type: 'Promo::PeriodicPriceReduction'
    }
]

export const lotteryMerchants = [
    {
        back_office_user_id: 111,
        category: 'Sklep tradycyjny (Detal)',
        city: 'Warszawa',
        created_at: '2018-04-12T11:01:41.648+02:00',
        district: 'Mazowieckie',
        id: 111,
        is_test: false,
        marketing_segmentation: 'B',
        name: 'Sklep Mpromo 1',
        network: 'SC_SIEĆ 34/LD/LIVIO',
        nip: '123456789',
        number: '1',
        payer: 'PHU Mpromo',
        phone: null,
        postcode: '00-001',
        quartile: null,
        region: 'Centralny',
        short_name: 'Sklep Mpromo 1',
        state: 'active',
        street: 'Mazowiecka',
        updated_at: '2022-01-20T09:39:03.121+01:00'
    },
    {
        back_office_user_id: 222,
        category: 'Sklep tradycyjny (Detal)',
        city: 'Warszawa',
        created_at: '2018-04-12T11:01:41.648+02:00',
        district: 'Mazowieckie',
        id: 222,
        is_test: false,
        marketing_segmentation: 'B',
        name: 'Sklep Mpromo 2',
        network: 'SC_SIEĆ 34/LD/LIVIO',
        nip: '123456789',
        number: '2',
        payer: 'PHU Mpromo',
        phone: null,
        postcode: '00-001',
        quartile: null,
        region: 'Centralny',
        short_name: 'Sklep Mpromo 2',
        state: 'active',
        street: 'Mazowiecka',
        updated_at: '2022-01-20T09:39:03.121+01:00'
    }
]

export const lotteryLabels = lotteryPromotions.map(e => {
    return {
        ...e,
        labels: {
            1: {
                ean: '12345678902',
                name: 'Produkt promocyjny 1',
                image: {
                    urls: {
                        small: require('@/assets/logo-mpromo.svg')
                    }
                }
            },
            2: {
                ean: '12345678902',
                name: 'Produkt promocyjny 2',
                image: {
                    urls: {
                        small: require('@/assets/logo-mpromo.svg')
                    }
                }
            }
        }
    }
})